module.exports = __webpack_public_path__ + "media/images/charts/pemegang-saham-151cc99b7651954362c9355b233faf46.png";